"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationProfileTierType = void 0;
var LocationProfileTierType;
(function (LocationProfileTierType) {
    LocationProfileTierType[LocationProfileTierType["Tier 1"] = 1] = "Tier 1";
    LocationProfileTierType[LocationProfileTierType["Tier 2"] = 2] = "Tier 2";
    LocationProfileTierType[LocationProfileTierType["Tier 3"] = 3] = "Tier 3";
})(LocationProfileTierType = exports.LocationProfileTierType || (exports.LocationProfileTierType = {}));
//# sourceMappingURL=LocationProfileTierType.js.map